// extracted by mini-css-extract-plugin
export default {"card":"tQ-z","defaultCard":"uQ-z","cardDetails":"vQ-z","cardActions":"wQ-z","separator":"xQ-z"};